import styled from 'styled-components'
import {Radio} from 'react-radio-group'
import breakpoint from 'components/breakpoint'
import config from 'config'

const RadioGroupView = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint('middleMobile')`
    flex-direction: ${props => (props.vertical ? 'column' : 'row')};
  `};
`

const radioDisplay = props => (props.inline ? 'inline-block' : 'block')
const radioPadding = props => (props.inline ? '0 24px 0 28px' : '0 0 8px 28px')
const radioColor = props =>
  props.disabled
    ? props.theme.radio.disabledColor || props.theme.field.label.disabledColor
    : props.theme.radio.color || props.theme.field.label.color
const cursor = props => (props.disabled ? 'auto' : 'pointer')

const RadioInputView = styled.label`
  position: relative;
  display: ${radioDisplay};
  padding: ${radioPadding};
  line-height: ${props => props.theme.radio.labelFontHeight};
  color: ${radioColor};
  font-size: ${props => props.theme.radio.fontSize || props.theme.font.mobile.size};
  font-family: ${props => props.theme.radio.fontFamily};
  font-weight: ${props => props.theme.radio.fontWeight};
  cursor: ${cursor};
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:not(:last-child) {
    margin-bottom: 12px;
  }

  ${breakpoint('middleMobile')`
    &&& {
      margin-bottom: 0px;
    }
  `};
`

const StyledRadio = styled(Radio)`
  position: absolute;
  opacity: 0;
  cursor: ${cursor};
  height: 0;
  width: 0;

  /* add for preloading icon */
  background: ${props => `url(${config.url}/assets/${props.theme.radio.icon.checkedImage})`} no-repeat -9999px -9999px,
    ${props => `url(${config.url}/assets/${props.theme.radio.icon.hoverImage})`} no-repeat -9999px -9999px,
    ${props => `url(${config.url}/assets/${props.theme.radio.icon.errorImage})`} no-repeat -9999px -9999px;
`

const ASSET_URL = `${config.url}/assets/`
const image = props => {
  let {image} = props.theme.radio.icon
  if (props.error) {
    image = props.theme.radio.icon.errorImage
  }

  if (props.disabled) {
    image = props.theme.radio.icon.disabledImage
  }

  return `url(${ASSET_URL}${image})`
}

const checkedImage = props =>
  `url(${ASSET_URL}${props.disabled ? props.theme.radio.icon.disabledImage : props.theme.radio.icon.checkedImage})`

const hoverImage = props =>
  `url(${ASSET_URL}${props.disabled ? props.theme.radio.icon.disabledImage : props.theme.radio.icon.hoverImage})`

const RadioCheckmark = styled.span`
  position: absolute;
  top: ${props => props.theme.radio.icon.top || '3px'};
  left: 0;
  width: ${props => props.theme.radio.icon.width};
  height: ${props => props.theme.radio.icon.height};
  background-image: ${image};
  border-radius: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${props => props.theme.background};

  /* Create the indicator (the dot/circle - hidden when not checked) */
  &:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  ${RadioInputView} ${StyledRadio}:checked ~ &, ${RadioInputView} ${StyledRadio}:checked:hover ~ & {
    display: block;
    background-image: ${checkedImage};
  }

  ${RadioInputView} ${StyledRadio}:hover ~ & {
    background-image: ${hoverImage};
  }
`
export {RadioGroupView, RadioInputView, StyledRadio, RadioCheckmark}
